import type { ToolsTreeNode } from "../../model/types";

export const filterToolsTree = (nodes: ToolsTreeNode[], query: string): ToolsTreeNode[] => {
	const needle = query.trim().toLowerCase();
	if (!needle) return nodes;

	return nodes.flatMap((node) => {
		if (`${node.title} ${node.description}`.toLowerCase().includes(needle)) return [node];
		const children = filterToolsTree(node.children, needle);
		return children.length ? [{ ...node, children }] : [];
	});
};
